export default "images/bg7.jpg";